/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

module.exports = function(data) {
  var deferred = $.Deferred();

  var eventJson = {
    location: {
      displayName: data.venueName,
      address:
        data.eventFormatId === '1'
          ? {
              city: data.venueAddress.city,
              postalCode: data.venueAddress.postalCode,
              state: data.venueAddress.state,
              street: data.venueAddress.streetAddress
            }
          : {}
    }
  };

  $.soap({
    body: {
      SubmitEditEventVenueDetails: {
        $xmlns: 'http://dobs.pa.gov/co/event/bpm/1.0',
        EventID: data.eventId,
        EntityID: data.venueId,
        ContactID: data.contactId,
        EventDetailsJSON: JSON.stringify(eventJson)
      }
    }
  })
    .done(function(response) {
      deferred.resolve();
    })
    .fail(function() {
      deferred.reject();
    });

  return deferred.promise();
};
